export default {
  settings: 'Setări',
  storefront: 'Vitrină',
  media: 'Media',
  style: 'Stil',
  scripts: 'Scripturi',
  no_google_place: {
    title: 'Compania nu este conectată la nicio locație Google',
    description: 'Vă rugăm să conectați compania la o locație Google',
  },
};
